import mutations from './pois.mutations'
import actions from './pois.actions'

const state = () => ({
    pois: [],
    poisLoaded: false,
    poisLoading: false,
    poiCategories: [],
    poisNotifications: {}
})

const getters = {}

export default {
    state,
    getters,
    mutations,
    actions
}
